import { useMutation, useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../apis/data";
import { useLocalStorage } from "../../context/useLocalStorage";
import localStorageKey from "../../enumerations/localStorageKey";
import { queryKey } from "../../enumerations/queryKey";
import { PostProfileParams, ProfileResponse } from "./data";
import { apiGetProfile, apiPostProfile } from "./service";

export const useGetProfile = (options: any) => {
  const [userInfo, setUserInfo] = useLocalStorage(
    localStorageKey.USER_INFO,
    undefined
  );
  return useQuery<ProfileResponse>({
    queryKey: [queryKey.PROFILE],
    queryFn: () =>
      apiGetProfile().then((res: ApiResponse<ProfileResponse>) => {
        setUserInfo(res.data.data);
        return res.data.data;
      }),
    ...options,
  });
};

export const usePostProfile = () => {
  return useMutation({
    mutationFn: ({ params }: { params: PostProfileParams }) =>
      apiPostProfile(params),
  });
};
